import type { SVGProps } from "react";
const SvgTopics = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 26 26" {...props}>
    <path stroke="currentColor" d="M.5 22.5h25v3H.5z" />
    <path stroke="currentColor" d="M.5 22.5h25v3H.5z" />
    <path stroke="currentColor" d="M.5 22.5h25v3H.5z" />
    <rect
      width={19.755}
      height={6.552}
      x={-0.353}
      y={0.612}
      className="icon-color-4"
      fill="#fff"
      rx={0.5}
      transform="rotate(74.989 9.307 14.554) skewX(-.022)"
    />
    <rect
      width={19.755}
      height={6.552}
      x={-0.353}
      y={0.612}
      stroke="currentColor"
      rx={0.5}
      transform="rotate(74.989 9.307 14.554) skewX(-.022)"
    />
    <rect
      width={19.755}
      height={6.552}
      x={-0.353}
      y={0.612}
      stroke="currentColor"
      rx={0.5}
      transform="rotate(74.989 9.307 14.554) skewX(-.022)"
    />
    <rect
      width={19.755}
      height={6.552}
      x={-0.353}
      y={0.612}
      stroke="currentColor"
      rx={0.5}
      transform="rotate(74.989 9.307 14.554) skewX(-.022)"
    />
    <rect
      width={17}
      height={7}
      x={8.5}
      y={5.5}
      className="icon-color-4"
      fill="#fff"
      rx={0.5}
      transform="rotate(90 8.5 5.5)"
    />
    <rect width={17} height={7} x={8.5} y={5.5} stroke="currentColor" rx={0.5} transform="rotate(90 8.5 5.5)" />
    <rect width={17} height={7} x={8.5} y={5.5} stroke="currentColor" rx={0.5} transform="rotate(90 8.5 5.5)" />
    <rect width={17} height={7} x={8.5} y={5.5} stroke="currentColor" rx={0.5} transform="rotate(90 8.5 5.5)" />
    <rect
      width={21}
      height={7}
      x={15.5}
      y={1.5}
      className="icon-color-4"
      fill="#fff"
      rx={0.5}
      transform="rotate(90 15.5 1.5)"
    />
    <rect width={21} height={7} x={15.5} y={1.5} stroke="currentColor" rx={0.5} transform="rotate(90 15.5 1.5)" />
    <rect width={21} height={7} x={15.5} y={1.5} stroke="currentColor" rx={0.5} transform="rotate(90 15.5 1.5)" />
    <rect width={21} height={7} x={15.5} y={1.5} stroke="currentColor" rx={0.5} transform="rotate(90 15.5 1.5)" />
    <path stroke="currentColor" strokeLinecap="round" d="M10.5 4.5h2M20.463 18.623l1.824-.489M4.5 7.5h2" />
  </svg>
);
export default SvgTopics;
